export const heroData = {
  tagline: "PLATAFORMA CLOUD",
  title: "Automatiza. Integra. Escala.",
  subtitle: "Tu plataforma todo-en-uno para gestionar servicios cloud, contratos, facturación y un marketplace SaaS con insights impulsados por IA.",
  cta: "Comenzar ahora",
  secondaryCta: "Ver demo"
};

export const statsData = [
  { number: "45+", label: "Mercados" },
  { number: "100+", label: "Soluciones con integración directa" },
  { number: "2M+", label: "Facturas emitidas" },
  { number: "99.9%", label: "Uptime garantizado" }
];

export const solutionsData = [
  {
    id: 1,
    title: "Distribuidores IT",
    description: "Automatiza la gestión de licencias y facturación para distribuidores de tecnología.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "MSPs",
    description: "Gestiona múltiples clientes y servicios cloud desde una única plataforma.",
    icon: "Server"
  },
  {
    id: 3,
    title: "Telcos",
    description: "Integra servicios cloud con tu infraestructura de telecomunicaciones.",
    icon: "Radio"
  }
];

export const featuresData = [
  {
    id: 1,
    title: "Cloud Marketplace",
    description: "Vende y gestiona más de 120 apps SaaS y servicios cloud con despliegue en 1 clic.",
    icon: "ShoppingCart"
  },
  {
    id: 2,
    title: "Automatización de Contratos",
    description: "Centraliza acuerdos, facturación y renovaciones en un solo lugar.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Insights con IA",
    description: "Reduce errores, predice churn y toma decisiones de negocio más rápidas.",
    icon: "Brain"
  },
  {
    id: 4,
    title: "Gestión de Suscripciones",
    description: "Facturación automatizada con control en tiempo real de ingresos.",
    icon: "CreditCard"
  },
  {
    id: 5,
    title: "CRM para Partners",
    description: "Conoce y gestiona tus clientes desde un único dashboard.",
    icon: "Users"
  },
  {
    id: 6,
    title: "Integraciones",
    description: "Azure, AWS, Google Cloud, Acronis y más en una sola plataforma.",
    icon: "Cloud"
  }
];

export const howItWorksData = [
  {
    step: 1,
    title: "Conecta",
    description: "Tus servicios y partners en minutos."
  },
  {
    step: 2,
    title: "Automatiza",
    description: "Ventas y procesos de back-office."
  },
  {
    step: 3,
    title: "Escala",
    description: "Con nuevas fuentes de ingresos e insights en tiempo real."
  }
];

export const testimonialsData = [
  {
    id: 1,
    quote: "Asisant ha transformado completamente nuestra gestión de licencias. Lo que antes tomaba días, ahora se hace en minutos.",
    author: "Carlos Rodríguez",
    role: "Director de Operaciones",
    company: "TechCloud Solutions",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 2,
    quote: "La automatización de facturación nos ha ahorrado un 70% en costes operativos y eliminado errores humanos.",
    author: "María González",
    role: "CFO",
    company: "DataServ LATAM",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face"
  },
  {
    id: 3,
    quote: "El marketplace white-label nos permitió lanzar nuestra tienda cloud en semanas, no meses.",
    author: "Andrés Martínez",
    role: "CEO",
    company: "CloudMaster Pro",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face"
  }
];

export const productsData = [
  {
    id: 1,
    title: "Certificación Uptime",
    description: "Validamos y certificamos el tiempo de actividad de tus servicios con certificados autenticados digitalmente.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Análisis de Seguridad",
    description: "Buscamos amenazas y vulnerabilidades mediante Ethical Hacking y pentesting.",
    icon: "Lock"
  },
  {
    id: 3,
    title: "Consultoría de Cumplimiento",
    description: "Apoyamos tu organización en cumplimiento de estándares ISO 27001:2013.",
    icon: "CheckCircle"
  },
  {
    id: 4,
    title: "CISO Virtual",
    description: "Solución accesible y efectiva para asegurar tus sistemas de información.",
    icon: "UserCog"
  }
];

export const faqData = [
  {
    question: "¿Qué es una plataforma de comercio por suscripción?",
    answer: "Es una solución que automatiza la gestión de productos, clientes y facturación recurrente para negocios cloud, eliminando procesos manuales y reduciendo errores."
  },
  {
    question: "¿Cómo funcionan las integraciones de proveedores?",
    answer: "Utilizamos conectores pre-construidos y APIs abiertas para sincronizar datos de productos y activar flujos de aprovisionamiento específicos de cada vendor."
  },
  {
    question: "¿Puedo personalizar el marketplace?",
    answer: "Sí, ofrecemos un marketplace white-label completamente personalizable con tu marca, colores y dominio propio."
  },
  {
    question: "¿Qué nivel de soporte ofrecen?",
    answer: "Ofrecemos soporte 24/7 con SLA garantizado, además de un equipo dedicado de customer success para tu onboarding."
  }
];

export const navLinks = [
  { label: "Soluciones", href: "#solutions" },
  { label: "Características", href: "#features" },
  { label: "Soluciones Avanzadas", href: "/soluciones-avanzadas" },
  { label: "Testimonios", href: "#testimonials" },
  { label: "FAQ", href: "#faq" }
];

export const footerData = {
  description: "Plataforma líder en automatización de comercio cloud para distribuidores IT, MSPs y Telcos.",
  links: {
    platform: [
      { label: "Cloud Marketplace", href: "/cloud-marketplace" },
      { label: "Facturación", href: "#" },
      { label: "Integraciones", href: "#" },
      { label: "API", href: "#" }
    ],
    company: [
      { label: "Sobre nosotros", href: "#" },
      { label: "Contacto", href: "#" },
      { label: "Blog", href: "#" },
      { label: "Carreras", href: "#" }
    ],
    legal: [
      { label: "Privacidad", href: "/privacidad" },
      { label: "Términos", href: "/terminos" }
    ]
  },
  social: [
    { platform: "Twitter", href: "#" },
    { platform: "LinkedIn", href: "#" },
    { platform: "Instagram", href: "#" }
  ]
};

export const partnersLogos = [
  "Microsoft",
  "AWS",
  "Google Cloud",
  "Adobe",
  "Acronis",
  "Dropbox"
];
